import Button from "components/Buttons/Button/Button";
import { regax } from "helpers/const";
import useAPI from "hooks/useAPI";
import { useEffect } from "react";
import { useState } from "react";
import styles from "./ForgotPassword.module.scss";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Loading from "components/Loading/Loading";
import { useTranslation } from "react-i18next";
import { printError } from "../../helpers/apiError";

const FrogotPasword = ({ openDialog, setOpenDialog, enteredEmail, translateKey }) => {
    const { t } = useTranslation();

    const api = useAPI();
    const [emailValue, setEmailValue] = useState(enteredEmail);
    const [message, setMessage] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isSent, setIsSent] = useState(false);

    useEffect(() => {
        if (openDialog) {
            setEmailValue(enteredEmail);
        } else {
            setIsSent(false);
            setIsLoading(false);
            setMessage(null);
        }
    }, [openDialog, enteredEmail]);

    const submitHandler = () => {
        let mail = emailValue.trim();
        setIsLoading(true);
        if (mail !== "" && regax.test(mail)) {
            api.post("customer/forgot-password", { email: mail })
                .then((response) => {
                    setIsLoading(false);
                    setMessage(response.message);
                    setIsSent(true);
                })
                .catch((error) => {
                    console.warn(error);
                    setMessage(printError(error) ? printError(error) : t("global-message-unknown_error"));
                    setIsLoading(false);
                });
        } else {
            setMessage(t(`${translateKey}-form-field-email-error-not_valid`));
        }
    };

    return (
        <Dialog
            open={openDialog}
            onClose={() => {
                setOpenDialog(false);
            }}
            fullWidth
        >
            <DialogTitle>{t(`${translateKey}-title`)}</DialogTitle>
            <DialogContent>
                <div className={styles.contentContainer}>
                    <p>{t(`${translateKey}-description`)}</p>

                    {!isLoading ? (
                        <>
                            {!isSent && (
                                <>
                                    <span>{t(`${translateKey}-form-field-email-label`)}</span>
                                    <input
                                        type="text"
                                        value={emailValue}
                                        onChange={(e) => {
                                            setEmailValue(e.currentTarget.value);
                                        }}
                                        className="form-control"
                                    />
                                </>
                            )}
                            {message && <span>{message}</span>}
                        </>
                    ) : (
                        <Loading size={50} />
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                {!isSent && <Button label={t(`${translateKey}-form-button-submit`)} onClick={submitHandler} />}

                <Button
                    onClick={() => {
                        setOpenDialog(false);
                    }}
                    label={t(`${translateKey}-form-button-close`)}
                />
            </DialogActions>
        </Dialog>
    );
};

export default FrogotPasword;
